export default "__VITE_ASSET__CEdKHdRa__"